import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';

import { showMsg } from '../../services/library';
import exportDMSService from '../../services/exportDMSService';

const REQ_EXPORTDMS = 'exportDMS/';

export const createNEditExportDMSReq = createAsyncThunk(
  `${REQ_EXPORTDMS}createExportDMS`,
  async ({ formdata }, { rejectWithValue }) => {
    try {
      const response = await exportDMSService.createExportDMS(formdata);
      if (response?.status) {
        showMsg(response.data[0]?.message, 'success');
        return { insertedData: response.data[0], status: response?.status };
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);
export const deleteExportDMSReq = createAsyncThunk(
  `${REQ_EXPORTDMS}deleteExportDMS`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await exportDMSService.deleteExportDMS({
        id: data?.exportdms_id,
        name: data?.exportdms_conn_host
      });
      if (response?.status) {
        showMsg(response?.message, 'success');
        return response;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

export const exportInventoryReq = createAsyncThunk(
  `${REQ_EXPORTDMS}exportInventory`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await exportDMSService.exportInventory({
        exportslug: data?.exportdms_slug
      });
      if (response?.status) {
        if (response?.data?.length) {
          showMsg(response?.data[0].message, 'success');
        }
        return response;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

export const createNEditDMSConfigReq = createAsyncThunk(
  `${REQ_EXPORTDMS}createNEditDMSConfig`,
  async (obj, { rejectWithValue }) => {
    try {
      const response = await exportDMSService.createDMSConfig(obj);
      if (response?.status) {
        showMsg(response?.message, 'success');
        return response;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

const FTP_VAR = 'FTP';
const SFTP_VAR = 'SFTP';
const PORT_OBJ = { [FTP_VAR]: 21, [SFTP_VAR]: 22 };

export const CONNECTION_TYPE_LIST = [
  { value: FTP_VAR, label: FTP_VAR },
  { value: SFTP_VAR, label: SFTP_VAR }
];
export const EXPORT_TYPE_LIST = [
  { value: 1, label: 'All Dealership' },
  { value: 2, label: 'All Dealership with Type' },
  { value: 3, label: 'Individual Dealership' },
  { value: 4, label: 'Individual Dealership with Type' }
];
export const ENCLOSE_ALL_FILED_LIST = [
  { id: 'encloseAllField1', value: '1', label: 'True' }, // double quotes
  { id: 'encloseAllField0', value: '0', label: 'False' }
];
export const INCLUDE_HEADER_LIST = [
  { id: 'includeHeader1', value: '1', label: 'True' },
  { id: 'includeHeader0', value: '0', label: 'False' }
];
export const FILENAME_OPTIONS = [
  '[D]', // Day of the month (1-31)
  '[DD]', // Day of the month (01-31)
  '[M]', // Month (1-12)
  '[MM]', // Month (01-12)
  '[YY]', // Two-digit year (00-99)
  '[YYYY]', // Four-digit year (0000-9999)
  '[H]', // Hour (0-23)
  '[HH]', // Hour (00-23)
  '[m]', // Minute (0-59)
  '[mm]', // Minute (00-59)
  '[s]', // Second (0-59)
  '[ss]', // Second (00-59)
  '[A]', // AM/PM
  '[a]', // am/pm
  '[DealerInvID]',
  '[Type]'
];

const EXPORT_INTERVAL = [
  { value: 1, label: 'Every 1 Hour' },
  { value: 2, label: 'Every 2 Hours' },
  { value: 3, label: 'Every 3 Hours' },
  { value: 4, label: 'Every 4 Hours' },
  { value: 6, label: 'Every 6 Hours' },
  { value: 8, label: 'Every 8 Hours' },
  { value: 12, label: 'Every 12 Hours' },
  { value: 24, label: 'Every 24 Hours' }
];
export { EXPORT_INTERVAL };

function createExportField(label, value, info = '') {
  const obj = { value: value, label: label, text: label, checked: false };
  if (value === 'images' || label === 'video') {
    obj.separator = ',';
  }
  if (value === 'last_updated') {
    obj.dateformat = null;
  }
  if (info) {
    obj.info = info;
  }
  return obj;
}
const ALL_EXPORT_FIELD_LIST = [
  { label: 'DealerId', value: 'dealer_id' },
  { label: 'DealershipName', value: 'user_displayname' },
  { label: 'StockNo', value: 'stock_no' },
  { label: 'VIN', value: 'vin' },
  { label: 'Type', value: 'inv_type' },
  { label: 'Year', value: 'inv_year' },
  { label: 'Make', value: 'inv_make' },
  { label: 'Model', value: 'inv_model' },
  { label: 'Body', value: 'inv_body' },
  { label: 'Location', value: 'inv_location' },
  { label: 'Transmission', value: 'inv_transmission' },
  { label: 'Trim', value: 'inv_trim' },
  { label: 'MSRP', value: 'inv_msrp' },
  { label: 'Price', value: 'inv_price' },
  { label: 'DoorCount', value: 'inv_doors' },
  { label: 'EngineCylinder', value: 'inv_engine_cylinders' },
  { label: 'EngineDisplacement', value: 'inv_engine_capacity' },
  { label: 'ExtColor', value: 'inv_ext_color' },
  { label: 'IntColor', value: 'inv_int_color' },
  { label: 'Photos', value: 'images' },
  { label: 'PhotoCount', value: 'inv_photo_count' },
  { label: 'DateAdded', value: 'inv_added' },
  { label: 'PriorOwner', value: 'inv_powner' },
  { label: 'Mileage', value: 'inv_mileage' },
  { label: 'Features', value: 'inv_features' },
  { label: 'Certified', value: 'inv_certified' },
  { label: 'FactoryCodes', value: 'inv_factory_codes' },
  { label: 'VDP URL', value: 'inv_vdpurl' },
  { label: 'Original Videos', value: 'video' },
  { label: 'Last Updated', value: 'last_updated' },
  { label: 'Published Video', value: 'published_video_url' },
  { label: 'Exterior 360', value: 'exterior360' },
  { label: 'Interior 360', value: 'interior360' },
  {
    label: 'Exterior 360 Original Video',
    value: 'exterior_360_original_video'
  },
  {
    label: 'Photo URL with info',
    value: 'photo_url_with_info',
    info: 'URL[TAB]Index[TAB]Type[TAB]Composition[TAB]'
  },
  {
    label: 'Raw Images',
    value: 'raw_images'
  }
];
const defaultSelected = [
  'dealer_id',
  'vin',
  'last_updated',
  'images',
  'stock_no',
  'video',
  'interior360',
  'exterior360'
];

const DEFAULT_EXPORT_FIELD_LIST = ALL_EXPORT_FIELD_LIST?.filter(x => defaultSelected.includes(x.value))?.sort(
  (a, b) => a.label.localeCompare(b.label)
);
const AVAILABLE_EXPORT_FIELD_LIST = ALL_EXPORT_FIELD_LIST?.filter(x => !defaultSelected.includes(x.value))
  ?.map(field => createExportField(field.label, field.value, field?.info))
  ?.sort((a, b) => a.label.localeCompare(b.label));

const initialState = {
  exportDMSTabs: true,
  exportDMSId: 0,
  txtDMSName: '',
  txtDMSSlug: '',
  connectionTypeFTP: FTP_VAR,
  connectionType_Host: '',
  connection_Path: '',
  connectionType_Port: PORT_OBJ,
  connectionType_Username: '',
  connectionType_Password: '',
  connectionType_Verify: false,
  exportTypeSelection: null,
  exportTxtFilename: '',
  txtFieldSeperator: ',',
  encloseAllFieldSelection: ENCLOSE_ALL_FILED_LIST[0].value,
  includeHeaderSelection: INCLUDE_HEADER_LIST[0].value,
  lastexportChecked: false,
  decodeUrl: false,
  encryptUrl: false,
  addImperfectionParam: false,
  transparentImage: false,
  webpImage: false,
  withoutPromoBanner: false,
  exportField: AVAILABLE_EXPORT_FIELD_LIST,
  exportFieldAssigned: DEFAULT_EXPORT_FIELD_LIST,
  exportInterval: EXPORT_INTERVAL[0]
};

const ExportDMSSlice = createSlice({
  name: 'exportDMS',
  initialState,
  reducers: {
    handleEditData: {
      reducer(state, action) {
        const { connectionType_Port, exportDMSTabs } = current(state);
        const {
          exportdms_id,
          exportdms_conn_host,
          exportdms_conn_path,
          exportdms_conn_password,
          exportdms_conn_port,
          exportdms_conn_type,
          exportdms_conn_username,
          exportdms_encloseallfields,
          exportdms_includeheader,
          exportdms_export_fields,
          exportdms_export_type,
          exportdms_field_seperator,
          exportdms_filename,
          exportdms_name,
          exportdms_slug,
          exportdms_lastexport,
          exportdms_decodeurl,
          exportdms_encrypturl,
          exportdms_addimperfection,
          exportdms_transparent_image,
          exportdms_webp_image,
          exportdms_without_promobanner,
          exportdms_interval
        } = action.payload || {};

        const exportFieldAssigned = exportdms_export_fields
          ? typeof exportdms_export_fields === 'string'
            ? JSON.parse(exportdms_export_fields)
            : exportdms_export_fields
          : [];

        const assignedValues = exportFieldAssigned.map(item => item.value);
        const filteredFields = ALL_EXPORT_FIELD_LIST?.filter(x => !assignedValues.includes(x.value))
          ?.map(field => createExportField(field.label, field.value, field?.info))
          ?.sort((a, b) => a.label.localeCompare(b.label));

        state.exportDMSId = exportdms_id;
        state.txtDMSName = exportdms_name;
        state.txtDMSSlug = exportdms_slug;
        state.connectionTypeFTP = exportdms_conn_type;
        state.connectionType_Host = exportdms_conn_host;
        state.connection_Path = exportdms_conn_path || '';
        state.connectionType_Port = { ...connectionType_Port, [exportdms_conn_type]: exportdms_conn_port };
        state.connectionType_Username = exportdms_conn_username;
        state.connectionType_Password = exportdms_conn_password;
        state.exportTypeSelection = EXPORT_TYPE_LIST.find(x => x.value === exportdms_export_type);
        state.exportTxtFilename = exportdms_filename;
        state.txtFieldSeperator = exportdms_field_seperator;
        state.encloseAllFieldSelection = exportdms_encloseallfields?.toString();
        state.includeHeaderSelection = exportdms_includeheader?.toString();
        state.lastexportChecked = exportdms_lastexport;
        state.decodeUrl = exportdms_decodeurl;
        state.encryptUrl = exportdms_encrypturl;
        state.addImperfectionParam = exportdms_addimperfection;
        state.transparentImage = exportdms_transparent_image;
        state.webpImage = exportdms_webp_image;
        state.withoutPromoBanner = exportdms_without_promobanner;
        state.exportFieldAssigned = exportFieldAssigned;
        state.exportField = filteredFields;
        state.exportDMSTabs = !exportDMSTabs;
        state.connectionType_Verify = true;
        state.exportInterval = exportdms_interval
          ? EXPORT_INTERVAL.find(x => x.value === exportdms_interval)
          : EXPORT_INTERVAL[0];
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleResetStates: {
      reducer(state) {
        const { exportDMSTabs } = current(state);
        state.exportDMSTabs = !exportDMSTabs;
        state.exportDMSId = 0;
        state.txtDMSName = '';
        state.txtDMSSlug = '';
        state.connectionTypeFTP = FTP_VAR;
        state.connectionType_Host = '';
        state.connection_Path = '';
        state.connectionType_Port = PORT_OBJ;
        state.connectionType_Username = '';
        state.connectionType_Password = '';
        state.exportTypeSelection = null;
        state.exportTxtFilename = '';
        state.txtFieldSeperator = ',';
        state.encloseAllFieldSelection = ENCLOSE_ALL_FILED_LIST[0].value;
        state.includeHeaderSelection = INCLUDE_HEADER_LIST[0].value;
        state.exportFieldAssigned = DEFAULT_EXPORT_FIELD_LIST;
        state.exportField = AVAILABLE_EXPORT_FIELD_LIST;
        state.lastexportChecked = false;
        state.decodeUrl = false;
        state.encryptUrl = false;
        state.addImperfectionParam = false;
        state.transparentImage = false;
        state.webpImage = false;
        state.withoutPromoBanner = false;
        state.connectionType_Verify = false;
        state.exportInterval = EXPORT_INTERVAL[0];
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleExportDMSTabs: {
      reducer(state, action) {
        state.exportDMSTabs = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTxtDMSName: {
      reducer(state, action) {
        state.txtDMSName = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTxtDMSSlug: {
      reducer(state, action) {
        state.txtDMSSlug = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleLastExportToggle: {
      reducer(state, action) {
        state.lastexportChecked = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleDecodeurl: {
      reducer(state, action) {
        state.decodeUrl = action.payload;
        state.encryptUrl = 0;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleEncrypturl: {
      reducer(state, action) {
        state.encryptUrl = action.payload;
        state.decodeUrl = 0;
        state.webpImage = 0;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleAddImperfectionParam: {
      reducer(state, action) {
        state.addImperfectionParam = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTransparentImage: {
      reducer(state, action) {
        state.transparentImage = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleWebpImage: {
      reducer(state, action) {
        state.webpImage = action.payload;
        state.encryptUrl = 0;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePromoBanner: {
      reducer(state, action) {
        state.withoutPromoBanner = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleConnectionTypeFTP: {
      reducer(state, action) {
        state.connectionTypeFTP = action.payload;
        const { connectionType_Port } = current(state);
        state.connectionType_Port = connectionType_Port;
        state.connectionType_Verify = false;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleConnectionTypePort: {
      reducer(state, action) {
        const { connectionType_Port } = current(state);
        state.connectionType_Port = { ...connectionType_Port, ...action.payload };
        state.connectionType_Verify = false;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleConnectionTypeHost: {
      reducer(state, action) {
        state.connectionType_Host = action.payload;
        state.connectionType_Verify = false;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleConnectionPath: {
      reducer(state, action) {
        state.connection_Path = action.payload;
        state.connectionType_Verify = false;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleConnectionTypeUsername: {
      reducer(state, action) {
        state.connectionType_Username = action.payload;
        state.connectionType_Verify = false;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleConnectionTypePassword: {
      reducer(state, action) {
        state.connectionType_Password = action.payload;
        state.connectionType_Verify = false;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleConnectionTypeVerify: {
      reducer(state, action) {
        console.log('called', action.payload);
        state.connectionType_Verify = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleExportTypeSelection: {
      reducer(state, action) {
        state.exportTypeSelection = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTxtExportFilename: {
      reducer(state, action) {
        state.exportTxtFilename = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTxtFieldSeperator: {
      reducer(state, action) {
        state.txtFieldSeperator = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleEncloseAllFieldSelection: {
      reducer(state, action) {
        state.encloseAllFieldSelection = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleIncludeHeaderSelection: {
      reducer(state, action) {
        state.includeHeaderSelection = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleExportFields: {
      reducer(state, action) {
        if (action.payload?.exportField) {
          state.exportField = action.payload?.exportField || [];
        }
        if (action.payload?.exportFieldAssigned) {
          state.exportFieldAssigned = action.payload?.exportFieldAssigned || [];
        }
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleChangeExportInterval: {
      reducer(state, action) {
        if (action.payload) {
          state.exportInterval = action.payload;
        }
      },
      prepare(e) {
        return { payload: e };
      }
    }
  }
});

export const {
  handleResetStates,
  handleEditData,
  handleExportDMSTabs,
  handleTxtDMSName,
  handleTxtDMSSlug,
  handleLastExportToggle,
  handleDecodeurl,
  handleEncrypturl,
  handleAddImperfectionParam,
  handleTransparentImage,
  handleWebpImage,
  handlePromoBanner,
  handleConnectionTypeFTP,
  handleConnectionTypePort,
  handleConnectionTypeHost,
  handleConnectionPath,
  handleConnectionTypeUsername,
  handleConnectionTypePassword,
  handleConnectionTypeVerify,
  handleExportTypeSelection,
  handleTxtExportFilename,
  handleTxtFieldSeperator,
  handleEncloseAllFieldSelection,
  handleIncludeHeaderSelection,
  handleExportFields,
  handleChangeExportInterval
} = ExportDMSSlice.actions;
export default ExportDMSSlice.reducer;
